import { RootState } from 'src/store/store';

export const selectUserLicenses = (state: RootState) =>
  state.userLicenses.userLicenses;

export const selectRenewableLicenses = (state: RootState) =>
  state.userLicenses.renewableLicenses;
